export default __webpack_public_path__ + "static/media/B46.322d0095.png";